import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const SurveyNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="url(#SurveyNotification1)" />
    <Path
      d="M7.48 9.667a.73.73 0 1 0 0-1.459.73.73 0 0 0 0 1.459ZM7.48 12.583a.73.73 0 1 0 0-1.458.73.73 0 0 0 0 1.458ZM7.48 15.5a.73.73 0 1 0 0-1.458.73.73 0 0 0 0 1.458ZM16.702 11.125h-7.07c-.303 0-.549.307-.549.685v.088c0 .379.246.685.549.685h7.07c.302 0 .548-.306.548-.685v-.088c0-.378-.245-.685-.548-.685ZM16.702 14.042h-7.07c-.303 0-.549.306-.549.685v.088c0 .378.246.685.549.685h7.07c.302 0 .548-.307.548-.685v-.088c0-.379-.245-.685-.548-.685ZM16.702 8.208h-7.07c-.303 0-.549.307-.549.686v.087c0 .379.246.686.549.686h7.07c.302 0 .548-.307.548-.686v-.087c0-.379-.245-.686-.548-.686Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="SurveyNotification1"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#FF607D" />
        <Stop offset="1" stopColor="#EB233F" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default SurveyNotification;
